/*
  This configuration is required to have the DatePicker months / weekdays etc being translated
*/
import moment from 'moment';
import esLocale from 'antd/es/date-picker/locale/es_ES';

// Properties required for moment and that are not set on date-picker locale
const esLocaleExtra = {
  months: [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
    'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
  ],
  monthsShort: [
    'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic',
  ],
  // Weekdays need to be defined starting on Sunday.
  // Otherwise the calendar that used "moment" will display the wrong weekday for ES
  weekdays: [
    'Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado',
  ],
  weekdaysShort: [
    'Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab',
  ],
  weekdaysMin: [
    'Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa',
  ],
};

const fullEsLocale = {
  ...esLocale,
  ...esLocaleExtra,
};

const completeDatePickerLocale = (locale) => {
  const localeTrans = getDatepickerLocale(locale);
  if (localeTrans) {
    moment.updateLocale(locale, localeTrans);
  } else {
    moment.locale(locale);
  }
};

const getDatepickerLocale = (lang) => {
  if (lang === 'es') {
    return fullEsLocale;
  }
  return null;
};

export {
  getDatepickerLocale,
  completeDatePickerLocale,
};
